import axios from "axios";
import { CHAPTER_LIST_DROPDOWN } from "../../../routes/routes";

// Real API URLs:
// GET /reports/category-wise-members?chapter_id=&status=&search=
// GET /reports/category-wise-members/:categoryId/members?chapter_id=&status=

/**
 * Fetch chapters dropdown from DB
 */
export const getChaptersList = async () => {
  try {
    const response = await axios.get(CHAPTER_LIST_DROPDOWN, {
      params: { show_all: 1 },
    });
    if (response.data && response.data.success && Array.isArray(response.data.data)) {
      return response.data.data.map((ch) => ({
        value: String(ch.value),
        label: ch.label,
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching chapters:", err);
    return [];
  }
};

/**
 * Fetch category summary from real DB endpoint
 * @param {Object} params - { chapterId, status, search }
 * @returns {Promise<Array>} List of category summaries
 */
export const getCategorySummary = async ({ chapterId = "all", status = "all", search = "" } = {}) => {
  const response = await axios.get("/reports/category-wise-members", {
    params: {
      chapter_id: chapterId,
      status,
      search,
    },
  });

  if (response.data && response.data.success) {
    return response.data.data.categories || [];
  }
  throw new Error(response.data?.message || "Failed to load category summary data.");
};

/**
 * Fetch member list for a specific category from real DB endpoint
 * @param {string|number} categoryId
 * @param {Object} params - { chapterId, status }
 * @returns {Promise<Array>} List of members in this category
 */
export const getCategoryMembers = async (categoryId, { chapterId = "all", status = "all" } = {}) => {
  const response = await axios.get(`/reports/category-wise-members/${categoryId}/members`, {
    params: {
      chapter_id: chapterId,
      status,
    },
  });

  if (response.data && response.data.success) {
    return response.data.data.members || [];
  }
  throw new Error(response.data?.message || "Failed to load category members.");
};
